import type { WarpGrepProvider } from '../../providers/types.js';
import { AGENT_CONFIG } from '../config.js';
import path from 'path';

export async function toolListDirectory(
  provider: WarpGrepProvider,
  args: { path: string; pattern?: string | null; maxResults?: number; maxDepth?: number },
  repoRoot?: string,
): Promise<string> {

  const maxResults = args.maxResults ?? AGENT_CONFIG.MAX_LIST_RESULTS;
  const maxDepth = args.maxDepth ?? AGENT_CONFIG.MAX_LIST_DEPTH;

  const entries = await provider.listDirectory({
    path: args.path,
    pattern: args.pattern ?? null,
    maxResults,
    maxDepth,
  });

  if (!entries.length) return 'empty';

  // Flat absolute paths (matches training format)
  // If repoRoot is available, convert relative paths to absolute
  if (repoRoot) {
    const absRoot = repoRoot;
    const lines = entries.map(e => path.join(absRoot, e.path));
    return lines.join('\n');
  }

  // Fallback: return relative paths if repoRoot not available
  return entries.map(e => e.path).join('\n');
}
